import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import {
  changeLayout,
  changeLayoutMode,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";
import { getInitialThemeMode } from "../../shared/utils/theme";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const selectLayoutProperties = createSelector(
  (state) => state.Layout,
  (layout) => ({
    leftSideBarThemeImage: layout.leftSideBarThemeImage,
    leftSideBarType: layout.leftSideBarType,
    layoutWidth: layout.layoutWidth,
    topbarTheme: layout.topbarTheme,
    leftSideBarTheme: layout.leftSideBarTheme,
    layoutModeType: layout.layoutModeType,
  })
);

/**
 * App shell for authenticated pages. Mounted once (layout route with
 * <Outlet/> in App.js), so Header/Sidebar/Footer no longer remount and
 * re-run their effects on every navigation.
 */
const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const {
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    leftSideBarTheme,
    layoutModeType,
  } = useSelector(selectLayoutProperties);

  const isMobile = window.matchMedia
    ? window.matchMedia("(max-width: 991.98px)").matches
    : /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  useEffect(() => {
    dispatch(changeLayout("vertical"));
    dispatch(changeLayoutMode(getInitialThemeMode()));
  }, [dispatch]);

  useEffect(() => { if (leftSideBarTheme) dispatch(changeSidebarTheme(leftSideBarTheme)); }, [leftSideBarTheme, dispatch]);
  useEffect(() => { if (layoutModeType) dispatch(changeLayoutMode(layoutModeType)); }, [layoutModeType, dispatch]);
  useEffect(() => { if (leftSideBarThemeImage) dispatch(changeSidebarThemeImage(leftSideBarThemeImage)); }, [leftSideBarThemeImage, dispatch]);
  useEffect(() => { if (layoutWidth) dispatch(changeLayoutWidth(layoutWidth)); }, [layoutWidth, dispatch]);
  useEffect(() => { if (leftSideBarType) dispatch(changeSidebarType(leftSideBarType)); }, [leftSideBarType, dispatch]);
  useEffect(() => { if (topbarTheme) dispatch(changeTopbarTheme(topbarTheme)); }, [topbarTheme, dispatch]);

  return (
    <div id="layout-wrapper">
      <Header toggleMenuCallback={toggleMenuCallback} />
      <Sidebar theme={leftSideBarTheme} type={leftSideBarType} isMobile={isMobile} />
      <div className="main-content">{children}</div>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
